import { ListChecks } from 'lucide-react';
import type { Recommendation } from '../../data/schemas';
import type { ActionPlan } from '../../types/result';
import { SectionHeading } from './SectionHeading';

interface ActionPlanSectionProps {
  actionPlan: ActionPlan;
  catalog: readonly Recommendation[];
}

const GROUP_LABELS: { key: keyof ActionPlan; title: string }[] = [
  { key: 'first', title: 'Zuerst' },
  { key: 'next', title: 'Danach' },
  { key: 'later', title: 'Später' },
];

/** Priorisierter Handlungsplan „Zuerst / Danach / Später“ (Abschnitt 21.4). */
export function ActionPlanSection({ actionPlan, catalog }: ActionPlanSectionProps) {
  const hasAnyRecommendation = GROUP_LABELS.some((group) => actionPlan[group.key].length > 0);

  if (!hasAnyRecommendation) {
    return (
      <section className="stack">
        <SectionHeading icon={ListChecks}>Nächste Schritte</SectionHeading>
        <p className="card card--muted">
          Aktuell ergeben sich aus deinen Antworten keine zusätzlichen priorisierten
          Handlungsschritte.
        </p>
      </section>
    );
  }

  return (
    <section className="stack">
      <SectionHeading icon={ListChecks}>Nächste Schritte</SectionHeading>
      {GROUP_LABELS.map((group) => {
        const ids = actionPlan[group.key];
        if (ids.length === 0) return null;
        return (
          <div key={group.key} className="stack">
            <h3>{group.title}</h3>
            <div className="cluster-grid">
              {ids.map((id) => {
                const recommendation = catalog.find((r) => r.id === id);
                if (!recommendation) return null;
                return (
                  <article key={id} className="card">
                    <h4>{recommendation.title}</h4>
                    <p>{recommendation.description}</p>
                    <ul>
                      {recommendation.actionItems.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </article>
                );
              })}
            </div>
          </div>
        );
      })}
    </section>
  );
}
